<template functional>
  <button
    type="button"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <mia-streamline-icon
      class="w-6 h-6 transition-transform duration-300 transform fill-current ease-out-fast"
      :class="{
        'rotate-0': props.collapsed,
        'rotate-180': !props.collapsed,
      }"
      src="arrow-down-1"
    />
  </button>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'MiaCollapsibleToggleButton',

  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
